import React from 'react';
import { createRoot } from 'react-dom/client';
import '@cloudscape-design/global-styles/index.css';
import { configureAmplify } from './config/amplify';
import App from './App';

// Initialize Amplify before rendering
configureAmplify();

// IMPORTANT: Importing signInWithRedirect registers a side-effect listener
// that handles the OAuth code exchange when the user is redirected back
// from Google/social sign-in. Without this import at the entry point,
// the code exchange never happens on the callback page.
// See: https://docs.amplify.aws/react/build-a-backend/auth/concepts/external-identity-providers/
import 'aws-amplify/auth/enable-oauth-listener';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
